const domainCampaign = process.env.REACT_APP_DOMAIN_CAMPAIGN;
const domainUtop = process.env.REACT_APP_DOMAIN_UTOP;
const END_POINTS = {
  CHECK_CAMPAIGN_URL: domainCampaign + "promotion/CheckCampaign",
  GET_PROVINCES_URL: domainCampaign + "cms/Cities",
  VALIDATE_CODE_URL: domainCampaign + "campaign/validate",
  REQUEST_SMS_OTP_URL: domainCampaign + "/auth/SmsOtp/RequestOtp",
  REQUEST_EMAIL_OTP_URL: domainCampaign + "/request-email-otp",
  OTP_LOG_URL: domainCampaign + "/campaign/OTPLog",
  VERIFY_OTP_URL: domainCampaign + "/auth/SmsOtp/VerifyOTP",
  REQUEST_LOGIN_URL: domainCampaign + "/psldp/otp/success",
  UPDATE_USER_INFO_URL: domainCampaign + "/update-info",
  REQUEST_GIGYA_URL: domainCampaign + "Gigya/GigyaRequest",
  EXCHANGE_CODE_URL: domainCampaign + "promotion/ExchangeCode",
  GET_REMAINING_URL: domainCampaign + "campaign/gift",
  GET_LIST_WINNER_BY_TYPE: domainCampaign + "promotion/GetWinners",
  GET_LIST_PICTURE: domainCampaign + "campaign/awarded/image",
  TOPUP_MOBILE_URL: domainUtop + "gift/Topup",
  GET_REMAINING_PRIZE: domainCampaign + "promotion/RemainingGifts",
  GET_DISTRICTS_URL: domainCampaign + "cms/DistrictsHaveMart",
  GET_MARTS_URL: domainCampaign + "cms/getmarts",
  UPDATE_DELIVERY_URL: domainCampaign + "promotion/UpdateDelivery",
  CHECK_PHONE_URL: domainCampaign + "promotion/CheckPhone",
  GOT_SLOTS: domainCampaign + "reservation/slots",
  BOOK_TICKET: domainCampaign + "reservation/booking",
};

export { END_POINTS };
